/** Client CRUD Modal Component */

import React from 'react';
import {
  Modal, Stack, TextInput, Button, Group
} from '@mantine/core';

/**
 * Client Modal - Create/Edit client
 * 
 * Props:
 * - open: boolean
 * - onClose: function
 * - mode: 'create' | 'edit'
 * - data: object - Client form data
 * - onChange: function
 * - onSubmit: function
 * - loading: boolean
 */
export const ClientModal = ({
  open,
  onClose,
  mode = 'create',
  data = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    notes: ''
  },
  onChange,
  onSubmit,
  loading = false
}) => {
  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={mode === 'create' ? 'Add Client' : 'Edit Client'}
      centered
    >
      <Stack gap="md">
        <TextInput
          label="First Name"
          placeholder="Enter first name"
          value={data.firstName}
          onChange={(e) => onChange('firstName', e.target.value)}
        />

        <TextInput
          label="Last Name"
          placeholder="Enter last name"
          value={data.lastName}
          onChange={(e) => onChange('lastName', e.target.value)}
        />

        <TextInput
          label="Email"
          placeholder="Enter email"
          type="email"
          value={data.email}
          onChange={(e) => onChange('email', e.target.value)}
        />

        <TextInput
          label="Phone"
          placeholder="Enter phone number"
          value={data.phone}
          onChange={(e) => onChange('phone', e.target.value)}
        />

        <TextInput
          label="Company"
          placeholder="Enter company name"
          value={data.company}
          onChange={(e) => onChange('company', e.target.value)}
        />

        <TextInput
          label="Notes"
          placeholder="Enter notes"
          value={data.notes}
          onChange={(e) => onChange('notes', e.target.value)}
        />

        <Group grow>
          <Button variant="light" onClick={onClose}>
            Cancel
          </Button>
          <Button loading={loading} onClick={onSubmit}>
            {mode === 'create' ? 'Add Client' : 'Update Client'}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ClientModal;
